export function getCurrentUrl(pathname: string) {
	return pathname.split(/[?#]/)[0];
}

export function checkIsActive(
	pathname: string,
	url: string,
	exact: boolean = false,
) {
	const current = getCurrentUrl(pathname);
	if (!current || !url) {
		return false;
	}

	if (current === url) {
		return true;
	}

	if (exact) {
		return false;
	}

	if (
		current === url || // exact match
		current.startsWith(`${url}/`) // match before a slash
	) {
		return true;
	}
	return false;
}
